<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Curso</h4></div>
      <div class="card-body">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="row">
              <div class="col-md-3">
                <label for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control"
                  placeholder="Digite um nome:"
                  v-model="state.curso.nome.value"
                />
                <span v-if="state.curso.nome.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label for="nome">Cordenador</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control"
                  placeholder="Nome  do cordenador do curso:"
                  v-model="state.curso.coordenador_curso.value"
                />
                <span
                  v-if="state.curso.coordenador_curso.error"
                  class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label for="valor">Valor do curso</label>
                <input
                  id="valor"
                  type="text"
                  class="form-control"
                  placeholder="Digite um valor:"
                  v-model="state.curso.valor.value"
                  v-mask-decimal.br="2"
                />
                <span v-if="state.curso.valor.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-3">
                <label for="valor">Link do curso</label>
                <input
                  id="valor"
                  type="text"
                  class="form-control"
                  placeholder="Insira um link:"
                  v-model="state.curso.link.value"
                />
                <span v-if="state.curso.link.error" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div class="col-md-6">
                <label>Imagem</label>
                <input
                  type="file"
                  class="form-control"
                  @change="adicionarImagem"
                />
                <span v-if="state.erro_imagem" class="text-danger"
                  >Este campo é obrigatório</span
                >
              </div>
              <div
                style="display: flex"
                class="col-md-6"
                v-if="state.imagem.imagem"
              >
                <img :src="state.imagem.imagem" class="imagem" />
                <button class="btn_deletar_imagem" @click="removerImagem">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    fill="currentColor"
                    class="bi bi-x-lg mb-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarCurso" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/cursos">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      curso: {
        id: "",
        nome: {
          value: "",
          error: false,
        },
        coordenador_curso: {
          value: "",
          error: false,
        },
        valor: {
          value: "",
          error: false,
        },
        link: {
          value: "",
          error: false,
        },
      },
      imagem: {},
      erro_imagem: false,
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchCurso();
      }
    });
    async function fetchCurso() {
      try {
        const { data } = await services.curso.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.curso.id = data.id;
        state.curso.nome.value = data.nome;
        state.curso.coordenador_curso.value = data.coordenador_curso;
        state.curso.valor.value = data.valor;
        state.curso.link.value = data.link;
        state.imagem.imagem = data.imagem;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarCurso() {
      var erro_validacao = false;

      if (state.curso.nome.value.length == 0) {
        state.curso.nome.error = true;
        erro_validacao = true;
      }
      if (state.curso.coordenador_curso.value.length == 0) {
        state.curso.coordenador_curso.error = true;
        erro_validacao = true;
      }
      if (state.curso.valor.value.length == 0) {
        state.curso.valor.error = true;
        erro_validacao = true;
      }
      if (state.curso.link.value.length == 0) {
        state.curso.link.error = true;
        erro_validacao = true;
      }
      if (state.imagem.imagem == null || state.imagem.imagem == undefined) {
        state.erro_imagem = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }
      let dados = new FormData();
      dados.append("nome", state.curso.nome.value);
      dados.append("coordenador_curso", state.curso.coordenador_curso.value);
      dados.append("valor", state.curso.valor.value);
      dados.append("link", state.curso.link.value);
      if (state.imagem.file != null && state.imagem.file != undefined) {
        dados.append("imagem", state.imagem.file);
      }
      if (!state.curso.id) {
        if (state.imagem.file == null || state.imagem.file == undefined) {
          alert("Anexar uma imagem!!!");
          return;
        }
        await services.curso
          .save({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Cursos" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        dados.append("id", state.curso.id);
        dados.append("_method", "PATCH");
        if (state.imagem.file != undefined) {
          try {
            await services.curso.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        await services.curso
          .update({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Cursos" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];
      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarCurso,
      router,
      state,
      adicionarImagem,
      removerImagem,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>